// Duits (de-DE), golf2App: zelfde vorm als golf2App.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm).
export const appChecklistDe = {
    title: 'Checkliste',
    hint: 'Was muss mit? Das Tablet zeigt die Liste neben dem Aufruf, und dein Kind hakt sie ab.',
    empty: 'Noch nichts auf der Liste. Wähle unten etwas aus oder füge selbst etwas hinzu.',
    suggestions: 'Vorschläge',
    suggestionAdd: '{label} hinzufügen',
    addAll: 'Alle hinzufügen',
    newLabel: 'Etwas anderes',
    newPlaceholder: 'Zum Beispiel: Schwimmbrille',
    add: 'Hinzufügen',
    labelRequired: 'Gib ein Wort ein.',
    labelTooLong: 'Höchstens 40 Zeichen.',
    max: 'Höchstens 12 Dinge pro Liste.',
    itemPicto: 'Bild für {label}',
    up: '{label} nach oben',
    down: '{label} nach unten',
    remove: '{label} entfernen',
    previewTitle: 'Neben dem Aufruf',
    sheetTitle: 'Mit in die Tasche',
    sheetProgress: '{done} von {total} eingepackt',
    sheetAllDone: 'Alles eingepackt',
    sheetNone: 'Noch nichts abgehakt',
    sheetItemDone: '{label}: eingepackt',
    sheetItemOpen: '{label}: noch nicht',
    items: {
        'swim-trunks': 'Badehose',
        swimsuit: 'Badeanzug',
        towel: 'Handtuch',
        underwear: 'Unterhose',
        socks: 'Socken',
        shampoo: 'Shampoo',
        slippers: 'Badelatschen',
        'football-boots': 'Fußballschuhe',
        'shin-guards': 'Schienbeinschoner',
        'water-bottle': 'Trinkflasche',
        quran: 'Koran',
        backpack: 'Tasche',
        headscarf: 'Kopftuch',
        'prayer-cap': 'Gebetskappe',
        coat: 'Jacke',
        shoes: 'Schuhe',
        lunch: 'Pausenbrot',
        fruit: 'Obst',
        homework: 'Hausaufgaben',
        reading: 'Lesebuch',
        'music-lesson': 'Notenheft',
        'get-dressed': 'Sportsachen',
    },
};
export const appActivitiesDe = {
    section: 'Feste Aktivität',
    toggle: 'Das ist eine feste Aktivität',
    toggleHint: 'Wie Schule, Moscheeunterricht oder Fußball: findet jede Woche statt, außer in den Ferien und Pausen, die du unten wählst.',
    needsRecurrence: 'Wähle zuerst eine Wiederholung: Eine feste Aktivität kommt jede Woche wieder.',
    followSchool: 'Richtet sich nach den Schulferien',
    followSchoolHint: 'In den Schulferien der Region {region} fällt diese Aktivität aus.',
    followSchoolNoRegion: 'Wähle unten über Einstellungen deine Schulferienregion. Diese Region gilt für die ganze Familie.',
    regions: { noord: 'Nord', midden: 'Mitte', zuid: 'Süd' },
    pauses: 'Pausen',
    pausesHint: 'Zeiträume, in denen diese Aktivität ruht. Eine Pause kannst du mit anderen Aktivitäten teilen.',
    noPauses: 'Noch keine Pausen.',
    newPause: 'Neue Pause',
    pauseName: 'Name',
    pauseNamePlaceholder: 'Sommerpause',
    pauseFrom: 'Von',
    pauseTo: 'Bis einschließlich',
    pauseAdd: 'Pause hinzufügen',
    pauseCancel: 'Abbrechen',
    pauseNameRequired: 'Gib der Pause einen Namen.',
    pauseRangeInvalid: 'Wähle ein Enddatum am oder nach dem Startdatum, innerhalb eines Jahres.',
    pausePresets: {
        zomerstop: 'Sommerpause',
        winterstop: 'Winterpause',
        zomervakantie: 'Sommerferien',
    },
    sharedWith: 'Auch bei: {names}',
    saved: 'Feste Aktivität gespeichert',
    saveFailed: 'Der Termin ist gespeichert, die Pausen aber nicht. Versuch es noch einmal.',
    barLabel: '{title}, {range}',
    schoolHoliday: 'Schulferien',
    pause: 'Pause',
    stops: 'Ruht: {names}',
    stopsNone: 'Dann ruht keine feste Aktivität.',
    sheetSchoolHint: 'Die Schulferien kommen von der niederländischen Regierung (Rijksoverheid), für deine Region. Eine feste Aktivität, die sich danach richtet, fällt dann aus.',
    sheetPauseHint: 'In diesem Zeitraum fallen die Aktivitäten unten aus: kein Aufruf, keine Fahrt.',
    editPause: 'Pause ändern',
    deletePause: 'Pause entfernen',
    deletePauseConfirm: 'Bist du sicher? Die Aktivitäten finden in diesem Zeitraum dann ganz normal statt.',
    pauseDeleted: 'Pause „{name}“ entfernt',
    pauseUpdated: 'Pause „{name}“ gespeichert',
    fixedChip: 'Feste Aktivität',
};
//# sourceMappingURL=golf2App.de.js.map